import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import {
  FormControlValidators,
  highlightInvalidControls,
} from '@domgen/dgx-fe-forms/shared';
import { ArticleSearchService } from '@self-fix/data-access';
import { ArticleSearchForm, CmsArticleSearchForm } from '@self-fix/util-models';
import { Observable, filter, skip } from 'rxjs';

@Injectable()
export class ArticleSearchFormComponentService {
  form!: FormGroup<ArticleSearchForm>;

  constructor(
    private readonly cmsContainer: CmsContainer<CmsArticleSearchForm>,
    private readonly articleSearchService: ArticleSearchService,
    private readonly formBuilder: FormBuilder,
    private readonly router: Router
  ) {}

  readonly vm$: Observable<CmsArticleSearchForm> = this.cmsContainer.content$;

  buildForm(): void {
    this.form = this.formBuilder.group<ArticleSearchForm>({
      search: this.formBuilder.control(
        null,
        Validators.compose([
          FormControlValidators.required(
            'Please input at least three letters to search'
          ),
          FormControlValidators.minimumLength(
            3,
            'Please input at least three letters to search'
          ),
        ])
      ),
    });
  }

  submit(term: string): void {
    this.router.navigate(['search'], { queryParams: { term } });
  }

  setArticleNotFoundErrors(): void {
    this.articleSearchService.articles$
      .pipe(
        skip(1),
        filter((articles) => articles.length === 0)
      )
      .subscribe(() => {
        this.form.controls.search.setErrors(
          {
            noResultsFound: 'noResultsFound',
          },
          { emitEvent: true }
        );

        highlightInvalidControls(this.form);
      });
  }
}
